import { Link } from 'react-router-dom'

/** Soren asks (allowlist): “What’s in the bank today?” — owner Mon/Tue flow. */
export default function SorenCashBankAsk({ show }: { show: boolean }) {
  if (!show) return null
  return (
    <div
      className="mx-5 my-3 rounded-xl border border-[var(--line)] bg-[var(--surface)] p-4"
      data-testid="soren-cash-bank-ask"
    >
      <p className="text-sm font-semibold text-[var(--ink)]">What&apos;s in the bank today?</p>
      <p className="text-xs text-[var(--ink3)] mt-1">Updates your 13-week forecast. Owners only.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Link
          to="/cash/forecast"
          className="inline-flex items-center rounded-lg bg-[#1A2230] px-3 py-2 text-xs font-semibold text-white no-underline"
        >
          Tell Soren
        </Link>
      </div>
    </div>
  )
}
